/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { z, ZodTypes } from '..';

export const defaultProjectI18n: Record<z.infer<typeof ZodTypes.Language>, { name: string; description: string }> = {
  en: {
    name: 'Default project',
    description: 'This project has been set up for you automatically.',
  },
  de: {
    name: 'Default Projekt',
    description: 'Dieses Projekt wurde automatisch für Sie angelegt.',
  },
};
